<p *ngFor="let alert of alerts$ | async">
  <pcs-alert-message
    [alert]="alert"
    [autoClose]="shouldAutoClose(alert)"
    (removed)="onRemoved($event)">
  </pcs-alert-message>
</p>
